(() => {
  if (customElements.get('asat-benefits-bar')) return;
  class AsatBenefitsBar extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      clearInterval(this.timer);
      this.controller = new AbortController();
      const options = {signal: this.controller.signal};
      this.items = [...this.querySelectorAll('[data-benefit]')];
      this.pauseButton = this.querySelector('[data-pause]');
      this.mobile = matchMedia('(max-width: 1023px)');
      this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
      this.index = 0;
      this.paused = this.reduced.matches;
      this.hovered = false;
      this.focused = false;
      this.querySelector('[data-next]').addEventListener('click', () => this.next(), options);
      this.pauseButton.addEventListener('click', () => { this.paused = !this.paused; this.update(); }, options);
      this.addEventListener('pointerenter', event => { if (event.pointerType === 'mouse') this.hovered = true; }, options);
      this.addEventListener('pointerleave', () => { this.hovered = false; }, options);
      this.addEventListener('focusin', () => { this.focused = true; }, options);
      this.addEventListener('focusout', event => { this.focused = this.contains(event.relatedTarget); }, options);
      this.mobile.addEventListener('change', () => this.update(), options);
      this.reduced.addEventListener('change', () => { this.paused = this.reduced.matches; this.update(); }, options);
      this.update();
      this.classList.add('is-ready');
      this.timer = setInterval(() => {
        if (this.mobile.matches && !this.paused && !this.hovered && !this.focused && !document.hidden) this.next();
      }, Math.max(5000, Number(this.dataset.interval) || 7000));
    }
    next() { this.index = (this.index + 1) % this.items.length; this.update(); }
    update() {
      this.items.forEach((item, index) => {
        item.dataset.active = String(index === this.index);
        if (this.mobile.matches && index !== this.index) item.setAttribute('aria-hidden', 'true');
        else item.removeAttribute('aria-hidden');
      });
      this.pauseButton.setAttribute('aria-pressed', String(this.paused));
      this.pauseButton.setAttribute('aria-label', this.paused ? this.dataset.playLabel : this.dataset.pauseLabel);
    }
    disconnectedCallback() { clearInterval(this.timer); this.controller?.abort(); }
  }
  customElements.define('asat-benefits-bar', AsatBenefitsBar);
})();
